export default {
  Auth: {
    region: process.env.REACT_APP_R_REGION,
    userPoolId: process.env.REACT_APP_R_USERPOOL_ID,
    userPoolWebClientId: process.env.REACT_APP_R_USERPOOL_WEBCLIENTID,
  },
};
